import { FC } from 'react';
import './PrevNext.scss';
import { ChevronLeft, ChevronRight } from './icons';

interface Props {
  entriesLength: number;
  barsPerSlide: number;
  offset: number;
  onPrev: () => void;
  onNext: () => void;
}

export const PrevNext: FC<Props> = ({
  entriesLength,
  barsPerSlide,
  offset,
  onPrev,
  onNext,
}) => {
  const leftDisabled = offset === 0;
  const rightDisabled = entriesLength - 1 < offset + barsPerSlide;
  return entriesLength > barsPerSlide ? (
    <div className="prev-next">
      <button
        className="prev-next__btn prev-next__btn--left"
        onClick={onPrev}
        disabled={leftDisabled}
      >
        <ChevronLeft disabled={leftDisabled} />
      </button>
      <button
        className="prev-next__btn prev-next__btn--right"
        onClick={onNext}
        disabled={rightDisabled}
      >
        <ChevronRight disabled={rightDisabled} />
      </button>
    </div>
  ) : null;
};
